import { combineReducers } from 'redux';
import authenticate from './authenticate';

/**
 * @desc combines the reducers into a root reducer when initializing set state. 
 */
export default combineReducers({
    logged_in: authenticate,
});